import {
  Component,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { CommitteeService } from '@src/core/services';
import { ObjectId } from '@src/types/id';

@Component({
  selector: 'app-organisation-committees',
  templateUrl: './organisation-committees.component.html',
  styleUrls: ['./organisation-committees.component.scss', '../styles/organisation-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganisationCommitteesComponent implements OnChanges {
  private readonly router = inject(Router);
  private readonly committeeService = inject(CommitteeService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() organisationId?: string;
  committees$ = this.committeeService.committeesForOrganisation$;

  loading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.organisationId) {
      this.committeeService.resetCommitteesForOrganisation();
      if (this.organisationId) {
        this.committeeService.getCommitteesByOrganisationId(this.organisationId, value => {
          this.loading = value;
          this.cdr.markForCheck();
        });
      }
    }
  }

  onSelectedCommitteeIdChange(committeeId?: ObjectId) {
    this.router.navigate(['committees', committeeId]);
  }
}
